import { QFilterGeneric } from './QFilterGeneric'

export class QFilterDirectories extends QFilterGeneric {
  name = "directories";
  class_name = "QFilterDirectories";
  api_name = 'directories';
  
  serialize(qfilters) {
    return encodeURIComponent(this.value);
  }
}
